import { AccessGuids, AlertClassColour, ApplicationNames, ConfigSystemParams, ErrorStrings, FieldAliases, LimitChangeBarring, msSize, SystemLocks } from 'src/app/core/consts';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, Observable, throwError } from 'rxjs';
import { ChartConfigService } from 'src/app/core/services/utelize/general/chart-config-service';
import { ChartCostsPerDayComponent } from 'src/app/shared/widget-no-formsmodalmodule/chart-costs-per-day/chart-costs-per-day.component';
import { ChartType } from './manage-esim.model';
import { ChartUsagePerDayComponent } from 'src/app/shared/widget-no-formsmodalmodule/chart-usage-per-day/chart-usage-per-day.component';
import { CompaniesService } from 'src/app/core/services/utelize/system/company/companies-service';
import { CompanyDTO } from 'src/app/core/models/system/company/company.dto';
import { CompanyUsageLimitDTO } from 'src/app/core/models/system/company/company-usage-limit.dto';
import { CompanyUsageLimitsService } from 'src/app/core/services/utelize/system/company/company-usage-limits-service';
import { CompletedModalFormComponent } from '../../_pop-ups/completed-modal-form/completed-modal-form.component';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ConfirmationModalFormComponent } from '../../_pop-ups/confirmation-modal-form/confirmation-modal-form.component';
import { DatePipe } from '@angular/common';
import { DateRange, eDeviceType, EspSystemEntities, eUser, LimitType, ThrottleType } from 'src/app/core/enums';
import { DeviceDTO } from 'src/app/core/models/system/device/device.dto';
import { DevicesService } from 'src/app/core/services/utelize/system/device/devices-service';
import { EsimLogProfileDTO } from 'src/app/core/models/system/webbing/esim-log-profile.dto';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { GlobalEventService } from 'src/app/core/services/utelize/general/global-event-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { ImeilockingModalFormComponent } from '../../imei-locking-modal-form/imei-locking-modal-form.component';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { LicencesCompanyAllocatedService } from 'src/app/core/services/utelize/system/licence/licences-company-allocated-service';
import { ManageEsimModalFormMoreComponent } from '../../_manage-sim/manage-esim-modal-form-more/manage-esim-modal-form-more.component';
import { MapSimLocationsComponent } from 'src/app/shared/widget-no-formsmodalmodule/map-sim-locations/map-sim-locations.component';
import { NgbModal, NgbModalRef, NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { OrderDTO } from 'src/app/core/models/system/order/order.dto';
import { OrderMiniDTO } from 'src/app/core/models/system/order/order-mini.dto';
import { OrdersService } from 'src/app/core/services/utelize/system/order/orders-service';
import { OrderUsageLimitsDTO } from 'src/app/core/models/system/order/order-usage-limits.dto';
import { OurDate } from 'src/app/core/interfaces/general/our-date';
import { populateOurDate } from 'src/app/core/functions-generic/functions-generic-date';
import { ProductsService } from 'src/app/core/services/utelize/system/product/products-service';
import { RedeployModalFormComponent } from '../../_provisioning/redeploy-modal-form/redeploy-modal-form.component';
import { RiskIntelligenceAccessService } from 'src/app/core/services/utelize/access/risk-intelligence/risk-intelligence-access.service';
import { SimStatusDisplay, SimStatusDisplay_EmptyObject } from 'src/app/core/interfaces/general/sim-status-display';
import { SimStatusService } from 'src/app/core/services/utelize/general/sim-status-service';
import { SuppliersService } from 'src/app/core/services/utelize/system/supplier/suppliers-service';
import { SystemLockDTO } from 'src/app/core/models/system/system-lock/system-lock.dto';
import { SystemLockService } from 'src/app/core/services/utelize/system/system-lock/system-lock-service';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { TimelineEsimModalFormComponent } from '../../_time-line/timeline-esim-modal-form/timeline-esim-modal-form.component';
import { TypesDeviceService } from 'src/app/core/services/utelize/system/type/types-device-service';
import { TypesOrderStatusService } from 'src/app/core/services/utelize/system/type/types-order-status-service';
import { UsageLimitsModalFormComponent } from '../../usage-limits-modal-form/usage-limits-modal-form.component';
import { UserDTO } from 'src/app/core/models/system/user/user.dto';
import { UserModalFormComponent } from '../../_user/user-modal-form/user-modal-form.component';
import { UsersService } from 'src/app/core/services/utelize/system/user/users-service';
import { WarningModalFormComponent } from '../../_pop-ups/warning-modal-form/warning-modal-form.component';
import { WebbingLiveDataDTO } from 'src/app/core/models/system/webbing/live-data.dto';
import { WebbingService } from 'src/app/core/services/utelize/system/webbing/webbing-service';
import { WidgetApplicationDetailsDTO } from 'src/app/core/models/system/widget/widget-application-details.dto'
import { WidgetService } from 'src/app/core/services/utelize/general/widget-service';

@Component({
  selector: 'app-manage-esim-modal-form',
  templateUrl: './manage-esim-modal-form.component.html',
  styleUrls: ['./manage-esim-modal-form.component.scss']
})

export class ManageEsimModalFormComponent implements AfterViewInit, OnDestroy, OnInit {
  
  @Input() disableTimelineIcon: boolean | undefined;
  
  @Output() eSimManagerFormCancelled : EventEmitter<void                                       >=new EventEmitter<void                                       >();
  @Output() orderDataHasBeenSaved    : EventEmitter<void                                       >=new EventEmitter<void                                       >();
  @Output() orderStatusHasBeenUpdated: EventEmitter<void                                       >=new EventEmitter<void                                       >();
  @Output() riskButtonClick          : EventEmitter<{ lastCountry: string; companyID: number; }>=new EventEmitter<{ lastCountry: string; companyID: number; }>();
  
  @ViewChild('applicationDayBorder',          { static: false }) applicationDayBorder!         : ElementRef;
  @ViewChild('applicationMonthBorder',        { static: false }) applicationMonthBorder!       : ElementRef;
  @ViewChild('ArrowNgbNav'                                     ) arrowNav!                     : NgbNav;
  @ViewChild('chartCostsPerDay',              { static: false }) chartCostsPerDay!             : ChartCostsPerDayComponent;
  @ViewChild('chartUsagePerDay',              { static: false }) chartUsagePerDay!             : ChartUsagePerDayComponent;
  @ViewChild('completedModalForm',            { static: false }) completedModalForm!           : CompletedModalFormComponent;
  @ViewChild('mapSimLocations',               { static: false }) mapSimLocations!              : MapSimLocationsComponent;
  @ViewChild('deleteSimConfirmationModal',    { static: false }) deleteSimConfirmationModal!   : ConfirmationModalFormComponent;
  @ViewChild('imeiLockEsim',                  { static: false }) imeiLockEsim!                 : ImeilockingModalFormComponent;
  @ViewChild('manageEsimModalForm',           { static: false }) manageEsimModalForm!          : TemplateRef<void>;
  @ViewChild('manageEsimMore',                { static: false }) manageEsimMore!               : ManageEsimModalFormMoreComponent;
  @ViewChild('redeployEsim',                  { static: false }) redeployEsim!                 : RedeployModalFormComponent;
  @ViewChild('resetNetworkConfirmationModal', { static: false }) resetNetworkConfirmationModal!: ConfirmationModalFormComponent;
  @ViewChild('timelineModalForm',             { static: false }) timelineModalForm!            : TimelineEsimModalFormComponent;
  @ViewChild('usageLimitsModalForm',          { static: false }) usageLimitsModalForm!         : UsageLimitsModalFormComponent;
  @ViewChild('userModalForm',                 { static: false }) userModalForm!                : UserModalFormComponent;
  @ViewChild('warningModalForm',              { static: false }) warningModalForm!             : WarningModalFormComponent;
  
  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false) }
            
  get fieldAliasUsername    () { return this.configSystemService.getValue(ConfigSystemParams.FieldAliasUsername,                    FieldAliases.FieldAliasUsername); }
  get hintCurrentSpendLimit () { return this.configSystemService.getValue(ConfigSystemParams.FormUsageLimitsHintCurrentSpendLimit,  "Current Spend Limit"          ); }
  get hintSelfAuthSpendLimit() { return this.configSystemService.getValue(ConfigSystemParams.FormUsageLimitsHintSelfAuthSpendLimit, "Self Authorised Spend Limit"  ); }
  get hintSpendLimit        () { return this.configSystemService.getValue(ConfigSystemParams.FormUsageLimitsHintSpendLimit,         "Spend Limit"                  ); }
  get textCurrentSpendLimit () { return this.configSystemService.getValue(ConfigSystemParams.FormUsageLimitsTextCurrentSpendLimit,  "Current Spend Limit"          ); }
  get textSelfAuthSpendLimit() { return this.configSystemService.getValue(ConfigSystemParams.FormUsageLimitsTextSelfAuthSpendLimit, "Self Authorised Spend Limit"  ); }
  get textSpendLimit        () { return this.configSystemService.getValue(ConfigSystemParams.FormUsageLimitsTextSpendLimit,         "Spend Limit"                  ); }
  
  get currentLimitType(): number {
    return this.currOrderUsageLimits?.limitType
        ?? this.sureSimOrder?.limitType
        ?? this.companyUsageLimits?.limitType
        ?? LimitType.Spend;
  }

  get limitSectionTitle() {
    if (this.currentLimitType===LimitType.Off  ) return 'Limit - Off';
    if (this.currentLimitType===LimitType.Data ) return 'Data Limit';
    if (this.currentLimitType===LimitType.Spend) return 'Spend Limit';
    return 'Limit';
  }

  get pendingLimitTypeName(): string {
    const type=this.possibleOrderUsageLimits?.limitType;
    if (type===LimitType.Off  ) return 'No Limit';
    if (type===LimitType.Data ) return 'Data Limit';
    if (type===LimitType.Spend) return 'Spend Limit';
    return '';
  }

  get pendingLimitTypeChanged(): boolean {
    return this.usageLimitsChanged &&
           this.possibleOrderUsageLimits?.limitType != null &&
           this.possibleOrderUsageLimits?.limitType !== this.currentLimitType;
  }

  get limitExceeded(): boolean {
    if (!this.sureSimOrder?.orderSpendDTO) return false;

    if (this.currentLimitType===LimitType.Spend) {
      return this.sureSimOrder.orderSpendDTO.cost > this.sureSimOrder.orderSpendDTO.usageLimit;
    }

    if (this.currentLimitType===LimitType.Data) {
      return (this.sureSimOrder.orderSpendDTO.dataLimitUsed ?? 0) >= 100;
    }

    return false;
  }

  get limitExceededText(): string {
    if (this.currentLimitType===LimitType.Data) return "This sim has exceeded it's data limit";
    return "This sim has exceeded it's spend limit";
  }

  public LimitType = LimitType;

  get getDataBeforeOpenModal      () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormManageEsimGetDataBeforeOpenModal,      true ); }
  get manageEsimVersion2          () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ManageEsimVersion2,                        false); }
  get showAlerts                  () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormManageEsimShowAlerts,                  false) || 
                                              this.componentAccessUserService.hasAccessGuid(AccessGuids.FormManageSIMShowAlerts                             ); }
  get showApplicationUsage        () { return this.featureEnabledApplicationGraphs                                                                           ; }
  get showExclusionProfiles       () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormManageEsimExclusionProfilesShow,       true ); }
  get showHintCurrentSpendLimit   () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUsageLimitsShowHintCurrentSpendLimit,  false); }
  get showHintSelfAuthSpendLimit  () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUsageLimitsShowHintSelfAuthSpendLimit, false); }
  get showHintSpendLimit          () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUsageLimitsShowHintSpendLimit,         false); }
  get showImeiLocking             () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowImeiLocking,                           true ); }
  get showLocationServices        () { return this.featureEnabledLocationServices                                                                            ; }
  get showRiskButton              () { return this.riskIntelligenceAccessService.canShow() && !!(this.sureSimOrder?.orderSpendDTO?.lastCountry ?? ''        ); }
  get showOrderLogTabIcons        () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowOrderLogTabIcons,                      false); }
  get showOrderTabIcons           () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowOrderTabIcons,                         true ); }
  get showNetworkReset            () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowNetworkReset,                          true ); }
  get showRedeploy                () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowRedeploy,                              true ); }
  get showSelfAuthSpendLimit      () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUsageLimitsShowSelfAuthSpendLimit,     false); }
  get showSupport                 () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowSupport,                               true ); }
  get showTimeline                () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormManageEsimTimelineShow,                true ); }
  get suppressOriginalWebbingError() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.WebbingSuppressOriginalError,              true ); }
  get systemLocksEnabled          () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.SystemLocksEnabled,                        true ); }
  get systemLocksShowDetails      () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.SystemLocksShowDetails,                    true ); }
  get systemLocksShowWarningModal () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.SystemLocksShowWarningModal,               true ); }

  public get isSimFormOpen()        : boolean { return this._isSimFormOpen;         }
  public get isViewCompanyLoading() : boolean { return this._isViewCompanyLoading;  }

  //#region NavItems

  public navItemSimDetails       : number=1;
  public navItemUsageData        : number=2;
  public navItemNetworkEvents    : number=3;
  public navItemLogs             : number=4;
  public navItemTimeline         : number=5;
  public navItemCompanyAlerts    : number=6;
  public navItemSupport          : number=7;
  public navItemLocationServices : number=8;

  public navItemLog_ProductChange: number=1;
  public navItemLog_eSIM         : number=2;
  public navItemLog_Communication: number=3;
  public navItemLog_UsageControl : number=4;
  public navItemLog_Alerts       : number=5;

  //#endregion
  
  private chartFilterDate                : OurDate | undefined=populateOurDate(this.exceptionsService, Date.now());
  private companyIdData!                 : CompanyDTO[];
  public  company                        : CompanyDTO | undefined;
  public  companyUsageLimits             : CompanyUsageLimitDTO | undefined;
  public  currOrderUsageLimits           : OrderUsageLimitsDTO | undefined;
  private deviceIdData!                  : IdAndDescriptionDTO[];
  private deviceTypeIdData!              : IdAndDescriptionDTO[];
  private doNotCloseForm                 : boolean = false;
  private enableFeaturesHasExecuted      : boolean=false;
  private eSimLogProfile                 : EsimLogProfileDTO | undefined;
  private featureEnabledApplicationGraphs: boolean=false;
  private featureEnabledLocationServices : boolean=false;
  private formTitleDefault               : string="Manage SIM";
  private imeiLockFormIsOpen             : boolean=false;
  private initialDeviceTag               : string="";
  private initialStatus                  : string="Please complete the following details";
  private _isSimFormOpen                 : boolean=false;
  private _isViewCompanyLoading          : boolean=false;
  private manageEsimModalFormRef!        : NgbModalRef;
  private manageMoreFormIsOpen           : boolean=false;
  private maxDayValue                    : number=0;
  private maxMonthValue                  : number=0;
  private openAtNavItem                  : number | undefined;
  private productIdData!                 : IdAndDescriptionDTO[];
  private redeployFormIsOpen             : boolean=false;
  private selectedCompany?               : CompanyDTO;
  private selectedUser?                  : IdAndDescriptionDTO;
  private statsGotApplication            : boolean=false;
  private statsGotApplicationTotal       : boolean=false;
  private statusIdData!                  : IdAndDescriptionDTO[];
  private subApplicationsDay            : string[]=[];
  private subApplicationsMonth          : string[]=[];
  private subApplictionDaySeries        : {name: string, data: number[]}[] = [];
  private subApplictionMonthSeries      : {name: string, data: number[]}[] = [];
  private supplierIdData!               : IdAndDescriptionDTO[];
  private sureSimUser                   : UserDTO | undefined;
  private systemLockId                  : number | undefined;
  private usageLimitsModalFormIsOpen    : boolean=false;
  private userIdData!                   : IdAndDescriptionDTO[];
  private userModalFormIsOpen           : boolean=false;
  
  public activeId                   : number=this.navItemSimDetails;
  public activeIdLogs               : number=this.navItemLog_ProductChange;
  public activeIdPrevious           : number=this.navItemSimDetails;
  public alertColourProgress        : string=AlertClassColour.Grey;
  public alertProduct               : string="";
  public applicationData            : WidgetApplicationDetailsDTO[] | undefined;
  public applicationDayChart!       : ChartType;
  public applicationDayChartUsage   : any | undefined;
  public applicationMonthChart!     : ChartType;
  public applicationMonthChartUsage : any | undefined;
  public applicationName            : string=ApplicationNames.SureSIM;
  public applicationTotalData       : WidgetApplicationDetailsDTO[] | undefined;
  public barred                     : boolean=false;
  public ceased                     : boolean=false;
  public companySelected            : boolean=false;
  public currProduct                : IdAndDescriptionDTO | undefined;
  public curUser                    : SystemUserDTO;
  public enableTimelineIcon         : boolean=false;
  public eSimManagerForm!           : UntypedFormGroup;
  public eSimManagerFormSubmitted   : boolean=false;
  public fileLockHoverText          : string | undefined;
  public formIsLocked               : boolean=false;
  public formTitle                  : string=this.formTitleDefault;
  public gotIccid                   : boolean=false;
  public iccidForEmbeddedPages      : string | undefined;
  public isPhysicalSim              : boolean=false;
  public limitChangeMessage         : string="";
  public liveDataFetched            : boolean=false;
  public loadingChart               : boolean=true;
  public loadingTotalChart          : boolean=true;
  public logsEsimForm!              : UntypedFormGroup;
  public newOrder                   : boolean=false;
  public orderDetailsForm!          : UntypedFormGroup;
  public orderNoForEmbeddedPages    : string | undefined;
  public possibleOrderUsageLimits   : OrderUsageLimitsDTO | undefined;
  public possibleProductID          : number | undefined;
  public productChanged             : boolean=false;
  public progressInformation        : string=this.initialStatus;
  public simOperationShowSpinner    : boolean=false;
  public simOpertationInProgress    : boolean=true;
  public submitButtonEnabled        : boolean=false;
  public sureSimDevice              : DeviceDTO | undefined;
  public sureSimLiveData            : WebbingLiveDataDTO | undefined;
  public sureSimOrder               : OrderDTO | undefined;
  public sureSimOrderId             : number | undefined;
  public usageDetailsForm!          : UntypedFormGroup;
  public usageLimitsChanged         : boolean=false;
  public warningMessageMain         : string | undefined;
  public warningMessageSub          : string | undefined;

  //#region for Validators
  
  public deviceTagMaxLength      : number=50;
  public emailMaxLength          : number=100;
  public mobileNumberMaxLength   : number=100;
  public msisdnMaxLength         : number=25;
  public orderNoMaxLength        : number=50;
  public supplierOrderNoMaxLength: number=32;

  //#endregion

  constructor(
    private authenticationService          : AuthenticationService,
    private chartConfigService             : ChartConfigService,
    private companiesService               : CompaniesService,
    private companyUsageLimitsService      : CompanyUsageLimitsService,
    private componentAccessUserService     : ComponentAccessUserService,
    private configSystemService            : ConfigSystemService,
    private datePipe                       : DatePipe,
    private devicesService                 : DevicesService,
    private exceptionsService              : ExceptionsService,
    private formBuilder                    : UntypedFormBuilder,
    private globalEventService             : GlobalEventService,
    private lastPassKillerService          : LastPassKillerService,
    private licencesCompanyAllocatedService: LicencesCompanyAllocatedService,
    private modalService                   : NgbModal,
    private ordersService                  : OrdersService,
    private orderStatusService             : TypesOrderStatusService,
    private productsService                : ProductsService,
    private riskIntelligenceAccessService  : RiskIntelligenceAccessService,
    private simStatusService               : SimStatusService,
    private suppliersService               : SuppliersService,
    private systemLockService              : SystemLockService,
    private typesDeviceService             : TypesDeviceService,
    private usersService                   : UsersService,
    private webbingService                 : WebbingService,
    private widgetService                  : WidgetService
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }

  public ngOnInit(): void {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngOnDestroy(): void {
    try {
      this.lastPassKillerService.stop();
      this.unsubscribeAllConnections();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public unsubscribeAllConnections(): void {
    try {
      this.chartCostsPerDay?.unsubscribeIccidTotalCost();
      this.chartUsagePerDay?.unsubscribeIccidTotalUsage();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public resetMainVariables(): void {
    try {
      this.activeId                       =this.navItemSimDetails;
      this.activeIdLogs                   =this.navItemLog_ProductChange;
      this.alertColourProgress            =AlertClassColour.Grey;
      this.alertProduct                   ="";
      this.applicationData                =undefined;
      this.applicationDayChartUsage       =[];
      this.applicationMonthChartUsage     =[];
      this.applicationTotalData           =undefined;
      this.barred                         =false;
      this.companySelected                =false;
      this.enableFeaturesHasExecuted      =false;
      this.enableTimelineIcon             =this.showTimeline && !this.disableTimelineIcon;
      this.eSimLogProfile                 =undefined;
      this.eSimManagerFormSubmitted       =false;
      this.featureEnabledApplicationGraphs=false;
      this.featureEnabledLocationServices =false;
      this.imeiLockFormIsOpen             =false;
      this.initialDeviceTag               ="";
      this.isPhysicalSim                  =false;
      this.gotIccid                       =false;
      this.liveDataFetched                =false;
      this.loadingChart                   =true;
      this.loadingTotalChart              =true;
      this.possibleOrderUsageLimits       =undefined;
      this.productChanged                 =false;
      this.progressInformation            =this.initialStatus;
      this.redeployFormIsOpen             =false;
      this.simOpertationInProgress        =true;
      this.simOperationShowSpinner        =false;
      this.statsGotApplication            =false;
      this.statsGotApplicationTotal       =false;
      this.submitButtonEnabled            =false;
      this.sureSimDevice                  =undefined;
      this.sureSimLiveData                =undefined;
      this.sureSimOrder                   =undefined;
      this.usageLimitsChanged             =false;
      this.userIdData                     =[];

      //RBW_20260413 - This has been moved to after the sureSimOrder data has been loaded, as you need the companyid to enable the features.
      // this.enableFeatures();
      this.setUpApplicationDayChart();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openForm(sureSimOrderId: number, openAtLocation: boolean = false): void {
    try {
      this.fileLockHoverText="Order is being edited by another";
      this.formIsLocked     =false;
      this.systemLockId     =undefined;

      this.resetMainVariables();

      if (openAtLocation) {
        this.featureEnabledLocationServices=true;
        this.openAtNavItem                 =this.navItemLocationServices;
      }
      this.refreshCompanyData();
      this.refreshDeviceData();
      this.refreshDeviceTypeData();
      this.refreshProductData(sureSimOrderId);
      this.refreshStatusData();
      this.refreshSupplierData();

      if (sureSimOrderId != undefined && <number>sureSimOrderId>0) {
        this.formTitleDefault="Manage SIM";
        this.formTitle       =this.formTitleDefault;
        this.newOrder        =false;
        this.sureSimOrderId  =sureSimOrderId;
        
        this.setUpForm();
        this.enableDisableControls(true);
        this.getSureSimOrderAndOpenModal();
      } else {
        this.formTitleDefault="Order SIM";
        this.formTitle       =this.formTitleDefault;
        this.newOrder        =true;
        this.sureSimOrderId  =0;

        this.setUpForm();
        this.enableDisableControls(false);
        this.openModal();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openFormByOrderNo(orderNo: string): void {
    try {
      //RBW_20260714 - Resolve by OrderNo (stable across limit changes / user reassignment) rather than the row's cached order id or the ICCID, so we always open the exact order that was clicked and never a stale/inactive or another user's order
      this.ordersService.getOrderIdByOrderNo(orderNo)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)));
        })
      )
      .subscribe({
        next : data  => { this.openForm(data.result); },
        error: error => {
          //RBW_20260714 - Emit cancelled so hosts relying on this modal (e.g. the usage grid) reset their "form is open" guard if the OrderNo->order id lookup fails; mirrors getSureSimOrderAndOpenModal
          this.eSimManagerFormCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openFormByIccid(iccid: string, openAtLocation: boolean = false): void {
    try {
      this.ordersService.getOrderIdByIccid(iccid)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)));
        })
      )
      .subscribe({
        next : data  => { this.openForm(data.result, openAtLocation); },
        error: error => {
          //RBW_20260714 - Emit cancelled so hosts relying on this modal (e.g. the usage grid) reset their "form is open" guard if the ICCID->order id lookup fails; mirrors getSureSimOrderAndOpenModal
          this.eSimManagerFormCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openModal(): void {
    try {
      this.manageEsimModalFormRef=this.modalService.open(this.manageEsimModalForm, { backdrop: this.modalBackGround,
                                                                                     centered: true,
                                                                                     keyboard: false,
                                                                                     size    : msSize.ExtraLarge });
      this._isSimFormOpen=true;
      this.manageEsimModalFormRef.result.then(
        () => { this._isSimFormOpen=false; },
        () => { this._isSimFormOpen=false; }
      );
    }
    catch(e) {
      this.eSimManagerFormCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region eSimManagerForm

  get formOfLogsEsimForm() {
    return this.logsEsimForm.controls;
  }

  get formOfOrderDetails() {
    return this.orderDetailsForm.controls;
  }

  public getSimStatus(): SimStatusDisplay {
    try {
      return this.simStatusService.getDisplay(this.formOfOrderDetails['status']?.value,
                                              this.formOfOrderDetails['statusDisplay']?.value,
                                              this.formOfOrderDetails['statusIcon']?.value);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return SimStatusDisplay_EmptyObject();
    }
  }

  get formOfUsageDetails() {
    return this.usageDetailsForm.controls;
  }
  
  private setUpForm() {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildForm() {
    try {
      this.removeFormFields(this.logsEsimForm);
      this.removeFormFields(this.orderDetailsForm);
      this.removeFormFields(this.usageDetailsForm);
      //Remove eSimManagerForm fields last
      this.removeFormFields(this.eSimManagerForm);

      this.eSimManagerForm  =this.formBuilder.group({ });
      this.logsEsimForm     =this.formBuilder.group({ });
      this.orderDetailsForm =this.formBuilder.group({ });
      this.usageDetailsForm =this.formBuilder.group({ });
      
      this.addFormFields(this.logsEsimForm);
      this.addFormFields(this.orderDetailsForm);
      this.addFormFields(this.usageDetailsForm);

      this.eSimManagerForm.addControl("logsEsimForm",     this.logsEsimForm);
      this.eSimManagerForm.addControl("orderDetailsForm", this.orderDetailsForm);
      this.eSimManagerForm.addControl("usageDetailsForm", this.usageDetailsForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.logsEsimForm) {
        this.addFormControl(formGroup, "account",               "", []);
        this.addFormControl(formGroup, "eid",                   "", []);
        this.addFormControl(formGroup, "email",                 "", []);
        this.addFormControl(formGroup, "lastEventLogTimeStamp", "", []);
        this.addFormControl(formGroup, "state",                 "", []);
        this.addFormControl(formGroup, "status",                "", []);

      } else if (formGroup==this.orderDetailsForm) {
        this.addFormControl(formGroup, "active",            true, []);
        this.addFormControl(formGroup, "barred",            "",   []);
        this.addFormControl(formGroup, "companyId",         "",   []);
        this.addFormControl(formGroup, "deviceId",          "",   []);
        this.addFormControl(formGroup, "deviceTag",         "",   []);
        this.addFormControl(formGroup, "deviceTypeId",      "",   []);
        this.addFormControl(formGroup, "eid",               "",   []);
        this.addFormControl(formGroup, "email",             "",   []);
        this.addFormControl(formGroup, "exclusionProfiles", "",   []);
        this.addFormControl(formGroup, "imeiLocking",       "",   []);
        this.addFormControl(formGroup, "liveApn",           "",   []);
        this.addFormControl(formGroup, "liveCountry",       "",   []);
        this.addFormControl(formGroup, "liveIccid",         "",   []);
        this.addFormControl(formGroup, "liveImei",          "",   []);
        this.addFormControl(formGroup, "liveIp",            "",   []);
        this.addFormControl(formGroup, "liveMccminc",       "",   []);
        this.addFormControl(formGroup, "liveModel",         "",   []);
        this.addFormControl(formGroup, "livePdp",           "",   []);
        this.addFormControl(formGroup, "liveVendor",        "",   []);
        this.addFormControl(formGroup, "liveVplmn",         "",   []);
        this.addFormControl(formGroup, "mobileNumber",      "",   []);
        this.addFormControl(formGroup, "msisdn",            "",   []);
        this.addFormControl(formGroup, "orderNo",           "",   []);
        this.addFormControl(formGroup, "productId",         "",   [Validators.required]);
        this.addFormControl(formGroup, "provisionedDate",   "",   []);
        this.addFormControl(formGroup, "status",            "",   []);
        this.addFormControl(formGroup, "statusDisplay",     "",   []);
        this.addFormControl(formGroup, "statusIcon",        "",   []);
        this.addFormControl(formGroup, "statusId",          "",   []);
        this.addFormControl(formGroup, "supplierId",        "",   []);
        this.addFormControl(formGroup, "supplierOrderNo",   "",   []);
        this.addFormControl(formGroup, "suspended",         "",   []);
        this.addFormControl(formGroup, "throttled64",       "",   []);
        this.addFormControl(formGroup, "throttled512",      "",   []);
        this.addFormControl(formGroup, "userId",            "",   []);
        
        this.orderDetailsForm.controls["companyId"].disable();
        this.orderDetailsForm.controls["userId"].disable();
      } else if (formGroup==this.usageDetailsForm) {
        this.addFormControl(formGroup, "currentMonthCost",      "", []);
        this.addFormControl(formGroup, "currentMonthUsage",     "", []);
        this.addFormControl(formGroup, "dataLimit",             "", []);
        this.addFormControl(formGroup, "dataLimitCurrent",      "", []);
        this.addFormControl(formGroup, "dataLimitUsedPercent",  "", []);
        this.addFormControl(formGroup, "lastCountryFlagIcon",   "", []);
        this.addFormControl(formGroup, "lastCountryUsage",      "", []);
        this.addFormControl(formGroup, "lastUsageDate",         "", []);
        this.addFormControl(formGroup, "limitCurrent",          "", []);
        this.addFormControl(formGroup, "limitSelfAuth",         "", []);
        this.addFormControl(formGroup, "usageLimit",            "", []);
        this.addFormControl(formGroup, "usageLimitUsedPercent", "", []);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : boolean | string,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private mobileForDisplay(user: UserDTO | undefined): string | undefined {
    try {
      if (user==undefined)
        return undefined;

      if (this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUserUseInternationalDialCode, false)
          && user.mobileE164 != null
          && user.mobileE164 != undefined
          && user.mobileE164.trim() != "")
        return user.mobileE164;

      return user.mobile;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return user?.mobile;
    }
  }

  private populateFormFields(formGroup: UntypedFormGroup, userDetailsOnly: boolean=false) {
    try {
      if (formGroup==this.logsEsimForm) {
        if (this.eSimLogProfile != undefined) {
          this.logsEsimForm.controls["eid"].setValue(this.eSimLogProfile.eid);
          this.logsEsimForm.controls["email"].setValue(this.eSimLogProfile.email);
          this.logsEsimForm.controls["lastEventLogTimeStamp"].setValue(this.datePipe.transform((new Date(this.eSimLogProfile.lastEventLogTimeStamp)), 'dd/MM/yyyy HH:mm:ss'));
          this.logsEsimForm.controls["state"].setValue(this.eSimLogProfile.state);
          this.logsEsimForm.controls["status"].setValue(this.eSimLogProfile.status);
        }

      } else if (formGroup==this.orderDetailsForm) {
        if (!userDetailsOnly) {
          this.orderDetailsForm.controls["exclusionProfiles"].setValue("");

          if (this.sureSimDevice != undefined) {
            this.alertProduct     = this.sureSimDevice.alertProduct;
            this.initialDeviceTag = this.sureSimDevice.tag;
            this.isPhysicalSim    = this.sureSimDevice.deviceTypeID == eDeviceType.sim;
            this.orderDetailsForm.controls["barred"].setValue(this.sureSimDevice.barred);
            this.orderDetailsForm.controls["deviceTag"].setValue(this.sureSimDevice.tag);
            this.orderDetailsForm.controls["deviceTypeId"].setValue(this.sureSimDevice.deviceTypeID);
            this.orderDetailsForm.controls["msisdn"].setValue(this.sureSimDevice.msisdn);
            this.orderDetailsForm.controls["suspended"].setValue(this.sureSimDevice.suspended);
            this.orderDetailsForm.controls["throttled64"].setValue(this.sureSimDevice.throttled64);
            this.orderDetailsForm.controls["throttled512"].setValue(this.sureSimDevice.throttled512);
          }

          if (this.sureSimLiveData != undefined) {
            this.orderDetailsForm.controls["liveApn"].setValue(this.sureSimLiveData.APN);
            this.orderDetailsForm.controls["liveCountry"].setValue(this.sureSimLiveData.CountryName);
            this.orderDetailsForm.controls["liveIccid"].setValue(this.sureSimLiveData.ICCID);
            this.orderDetailsForm.controls["liveImei"].setValue(this.sureSimLiveData.IMEI);
            this.orderDetailsForm.controls["liveIp"].setValue(this.sureSimLiveData.IP);
            this.orderDetailsForm.controls["liveMccminc"].setValue(this.sureSimLiveData.MCCMNC);
            this.orderDetailsForm.controls["liveModel"].setValue(this.sureSimLiveData.Model);
            this.orderDetailsForm.controls["livePdp"].setValue(this.sureSimLiveData.PDP);
            this.orderDetailsForm.controls["liveVendor"].setValue(this.sureSimLiveData.Vendor);
            this.orderDetailsForm.controls["liveVplmn"].setValue(this.sureSimLiveData.VPLMN);
          }

          if (this.sureSimOrder != undefined) {
            this.orderDetailsForm.controls["companyId"].setValue(this.sureSimOrder.companyID);
            this.orderDetailsForm.controls["deviceId"].setValue(this.sureSimOrder.deviceID);
            this.orderDetailsForm.controls["eid"].setValue(this.sureSimOrder.eid);
            this.orderDetailsForm.controls["imeiLocking"].setValue(this.sureSimOrder.imeiLocking);
            this.orderDetailsForm.controls["orderNo"].setValue(this.sureSimOrder.orderNo);
            this.orderDetailsForm.controls["productId"].setValue(this.sureSimOrder.productID);
            this.orderDetailsForm.controls["provisionedDate"].setValue(this.datePipe.transform((new Date(this.sureSimOrder.provisionedDate)), 'dd/MM/yyyy HH:mm:ss'));
            this.orderDetailsForm.controls["status"].setValue(this.sureSimOrder.status);
            this.orderDetailsForm.controls["statusDisplay"].setValue(this.sureSimOrder.statusDisplay);
            this.orderDetailsForm.controls["statusIcon"].setValue(this.sureSimOrder.statusIcon);
            this.orderDetailsForm.controls["statusId"].setValue(this.sureSimOrder.statusID);
            this.orderDetailsForm.controls["supplierId"].setValue(this.sureSimOrder.supplierID);
            this.orderDetailsForm.controls["supplierOrderNo"].setValue(this.sureSimOrder.supplierOrderNo);
            this.orderDetailsForm.controls["userId"].setValue(this.sureSimOrder.userID);

            this.simOpertationInProgress=false;
            this.enableDisableSimOperations(this.sureSimOrder.status);
          }        
        }

        if (this.sureSimUser != undefined) {
          this.logsEsimForm.controls["account"].setValue(this.sureSimUser.fullname);

          this.orderDetailsForm.controls["email"].setValue(this.sureSimUser.email);
          this.orderDetailsForm.controls["mobileNumber"].setValue(this.mobileForDisplay(this.sureSimUser));
        }

      } else if (formGroup== this.usageDetailsForm) {
        if (this.currOrderUsageLimits != undefined) {
          const effectiveDataLimit              =this.currOrderUsageLimits.dataLimit        ?? this.companyUsageLimits?.dataLimit;
          const effectiveDataLimitCurrent       =this.currOrderUsageLimits.dataLimitCurrent ?? this.currOrderUsageLimits.dataLimit ?? this.companyUsageLimits?.dataLimit;
          const effectiveDataWeightCode         =this.currOrderUsageLimits.dataLimitDataWeightCode ?? this.companyUsageLimits?.dataLimitDataWeightCode ?? "MB";
          const effectiveDataCurrentWeightCode  =this.currOrderUsageLimits.dataLimitCurrentDataWeightCode ?? this.currOrderUsageLimits.dataLimitDataWeightCode ?? this.companyUsageLimits?.dataLimitDataWeightCode ?? "MB";

          const symbol           =this.companyCurrencySymbol;
          const formatMoney      =(value: number | null | undefined): string | null => value==null ? null : symbol + Number(value).toFixed(2);
          const effectiveLimit          =this.currOrderUsageLimits.limit           ?? null;
          const effectiveLimitCurrent   =this.currOrderUsageLimits.limitCurrent    ?? this.currOrderUsageLimits.limit ?? null;
          const effectiveLimitSelfAuth  =this.currOrderUsageLimits.limitSelfAuth   ?? null;

          this.usageDetailsForm.controls["dataLimit"].setValue(effectiveDataLimit != null ? effectiveDataLimit + " " + effectiveDataWeightCode : null);
          this.usageDetailsForm.controls["dataLimitCurrent"].setValue(effectiveDataLimitCurrent != null ? effectiveDataLimitCurrent + " " + effectiveDataCurrentWeightCode : null);
          this.usageDetailsForm.controls["limitCurrent"].setValue(formatMoney(effectiveLimitCurrent));
          this.usageDetailsForm.controls["limitSelfAuth"].setValue(formatMoney(effectiveLimitSelfAuth));
          this.usageDetailsForm.controls["usageLimit"].setValue(formatMoney(effectiveLimit));
        }
        
        if (this.sureSimOrder != undefined && this.sureSimOrder.orderSpendDTO != undefined) {
          let lastUsageDate: Date | undefined | null = this.sureSimOrder.orderSpendDTO.lastUsage;

          this.usageDetailsForm.controls["currentMonthCost"].setValue(this.sureSimOrder.orderSpendDTO.costWithCurrencySymbol);
          this.usageDetailsForm.controls["currentMonthUsage"].setValue(this.sureSimOrder.orderSpendDTO.usageWithMbOrGb);
          this.usageDetailsForm.controls["dataLimitUsedPercent"].setValue(this.sureSimOrder.orderSpendDTO.dataLimitUsedWithPercent);
          this.usageDetailsForm.controls["lastCountryFlagIcon"].setValue(this.sureSimOrder.orderSpendDTO.lastCountryFlagIcon);
          this.usageDetailsForm.controls["lastCountryUsage"].setValue(this.sureSimOrder.orderSpendDTO.lastCountry);
          this.usageDetailsForm.controls["lastUsageDate"].setValue(lastUsageDate ? this.datePipe.transform((new Date(lastUsageDate)), 'dd/MM/yyyy HH:mm:ss') : undefined);
          this.usageDetailsForm.controls["usageLimitUsedPercent"].setValue(this.sureSimOrder.orderSpendDTO.limitUsedWithPercent);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private enableDisableControls(enabled: boolean) {
    try {
      this.submitButtonEnabled=enabled;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //RBW_20260713 - Location Settings live outside the reactive form, so enable Submit here when one of them changes
  public onSimLocationSettingsChanged(): void {
    try {
      this.enableDisableControls(true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public invalidInputs(): boolean {
    let valid = this.submitButtonEnabled || (this.orderDetailsForm.controls['deviceTag'].value != null && 
                                             this.orderDetailsForm.controls['deviceTag'].value?.trim() != (this.initialDeviceTag ?? ""));
    return !valid;
  }
  
  public eSimManagerFormSubmit() {
    try {
      this.eSimManagerFormSubmitted=true;

      if (!this.orderDetailsForm.valid) {
        this.arrowNav.select(this.navItemSimDetails);
        
      } else if (!this.usageDetailsForm.valid) {
        this.arrowNav.select(this.navItemLogs);

      } else {
        this.saveOrder();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public eSimManagerFormCancel() {
    try {
      this.unlockEntity();
      this.eSimManagerFormCancelled.emit();
      this.manageEsimModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Dropdown Arrays

  public getDropdownDataObjectArray(fieldName: string) {
    try {
      if (fieldName=="supplierId") {
        return this.supplierIdData;

      } else if (fieldName=="deviceId") {
        return this.deviceIdData;

      } else if (fieldName=="deviceTypeId") {
        return this.deviceTypeIdData;

      } else if (fieldName=="productId") {
        return this.productIdData;

      } else if (fieldName=="statusId") {
        return this.statusIdData;

      } else if (fieldName=="userId") {
        return this.userIdData;

      }
      
      return undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return undefined;
    }
  }

  public getDropdownDataObjectArray_Company() {
    try {
      return this.companyIdData;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return undefined;
    }
  }

  private getDropdownData(dataSource: Observable<any>, fieldName: string) {
    try {
      if (dataSource) {
        dataSource
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            if (fieldName=="companyId") {
              this.companyIdData=(data as CompanyDTO[]);

              this.companySelectDropDownChange(undefined);

            } else if (fieldName=="deviceId") {
              this.deviceIdData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="deviceTypeId") {
              this.deviceTypeIdData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="productId") {
              this.productIdData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="statusId") {
              this.statusIdData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="supplierId") {
              this.supplierIdData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="userId") {
              this.userIdData=(data as IdAndDescriptionDTO[]);

              this.userSelectDropDownChange(undefined);

            }
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Refresh Dropdown Arrays Data

  public refreshCompanyData() {
    try {
      this.getDropdownData(this.companiesService.getForLoggedInUser(this.curUser.userId), "companyId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshDeviceData() {
    try {
      this.getDropdownData(this.devicesService.getIdAndDescription(this.curUser.userId), "deviceId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshDeviceTypeData() {
    try {
      this.getDropdownData(this.typesDeviceService.getIdAndDescription(), "deviceTypeId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshProductData(sureSimOrderId: number) {
    try {
      this.getDropdownData(this.productsService.getAvailableIdAndDescription(sureSimOrderId), "productId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshStatusData() {
    try {
      this.getDropdownData(this.orderStatusService.getIdAndDescription(), "statusId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshSupplierData() {
    try {
      this.getDropdownData(this.suppliersService.getIdAndAlias(this.curUser.userId), "supplierId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshUserData() {
    try {
      let companyId: number=this.orderDetailsForm.get('companyId')?.value;
      
      this.getDropdownData(this.usersService.getIdAndFullNameByCompanyId(companyId), "userId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#endregion

  //#region SureSIM Company
  
  public companySelectDropDownChange(ev: any) {
    try {
      if (this.companyIdData==undefined)
        return;

      this.enableDisableControls(false);
      
      this.selectedCompany=this.companyIdData.find(x => x.id==this.orderDetailsForm.get('companyId')?.value);
      let gotCompany      =this.selectedCompany?.id != undefined && <number>this.selectedCompany?.id>0;      
  
      if (gotCompany) {
        this.refreshUserData();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public viewCompany(): void {
    try {
      if (this._isViewCompanyLoading) return;
      this._isViewCompanyLoading=true;

      const companyId: number=this.orderDetailsForm.get('companyId')?.value;

      this.globalEventService.broadcastCompanyClicked(
        companyId,
        (id) => { this._isViewCompanyLoading=false; 
                  this.companyDataHasBeenSaved(id); },
        ()   => { this._isViewCompanyLoading=false; }
      );
    }
    catch(e) {
      this._isViewCompanyLoading=false;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public companyDataHasBeenSaved(sureSimCompanyId: number | undefined) {
    try {
      if (sureSimCompanyId != undefined && <number>sureSimCompanyId>0) {
        this.refreshCompanyData();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
  
  //#region OpenModal Methods

  public getSureSimOrderAndOpenModal() {
    try {
      this.ordersService.getOrderWithSpend(<number>this.sureSimOrderId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.sureSimOrder           =data;
          this.orderNoForEmbeddedPages=this.sureSimOrder.orderNo;
          this.currProduct            =this.productIdData.find(x => x.id==(this.sureSimOrder!.productID ?? -1));
          this.enableDisableSimOperations(this.sureSimOrder.status);
          this.enableFeatures();

          if (!this.getDataBeforeOpenModal) {
            this.openModal();
            this.populateFormFields(this.orderDetailsForm, true);
            this.selectOpenAtNavItem();
          }
          this.processSystemLock();
          this.getCompanyUsageLimits();
          this.getSureSimDeviceAndOpenModal();

         },
        error: error => {
          this.eSimManagerFormCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getSureSimDeviceAndOpenModal(doNextOpenModalStep: boolean = true) {
    try {
      let deviceID=this.sureSimOrder?.deviceID==undefined ? -1 : this.sureSimOrder?.deviceID;

      this.devicesService.getById(<number>deviceID)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.sureSimDevice        =data;
          this.gotIccid             =this.sureSimDevice.imeiIccid != undefined && this.sureSimDevice.imeiIccid?.trim() != "";
          this.barred               =data.barred;
          this.formTitle            =this.formTitleDefault + " - " + this.sureSimDevice.imeiIccid;
          this.iccidForEmbeddedPages=this.sureSimDevice.imeiIccid;

          if (!this.getDataBeforeOpenModal) {
            this.populateFormFields(this.orderDetailsForm, true);
          }

          if (this.manageMoreFormIsOpen || this.redeployFormIsOpen || this.imeiLockFormIsOpen) {
            this.populateFormFields(this.orderDetailsForm, false);
            this.updateStatus();
            this.orderStatusHasBeenUpdated.emit();
            this.imeiLockFormIsOpen   = false;
            this.manageMoreFormIsOpen = false;
            this.redeployFormIsOpen   = false;
          }

          if (doNextOpenModalStep) {
            this.getEsimLogProfile(this.sureSimDevice.imeiIccid, this.sureSimOrderId ?? -1);
            this.getSureSimUserAndOpenModal(true);
          }
         },
        error: error => {
          this.eSimManagerFormCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public getSureSimUserAndOpenModal(doNextOpenModalStep: boolean) {
    try {
      let userID=this.sureSimOrder?.userID==undefined ? -1 : this.sureSimOrder?.userID;

      if (userID==undefined || userID<=0)
        return;

      this.usersService.getById(<number>userID)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.sureSimUser=data;

          if (doNextOpenModalStep) {
            if (!this.getDataBeforeOpenModal) {
              this.populateFormFields(this.orderDetailsForm, true);
            }

            this.getUsageLimitsAndOpenModal();
          }
          
          this.populateFormFields(this.orderDetailsForm, true);
         },
        error: error => {
          if (doNextOpenModalStep) {
            this.eSimManagerFormCancelled.emit();
          }

          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public get companyCurrencySymbol(): string {
    try {
      const fromOrderSpend=this.sureSimOrder?.orderSpendDTO?.currencySymbol;

      if (fromOrderSpend!=null && fromOrderSpend!=="")
        return fromOrderSpend;

      return this.company?.invoiceCurrencySymbol ?? "£";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "£";
    }
  }

  public getCompanyUsageLimits(): void {
    try {
      const companyID=this.sureSimOrder?.companyID ?? -1;

      if (companyID<=0) {
        return;
      }

      this.companiesService.getById(companyID)
      .pipe(
        catchError((error) => {
          this.exceptionsService.handleException(new Error(this.exceptionsService.formatHttpError(error)));
          return throwError(() => error);
        })
      )
      .subscribe({
        next: companyData => {
          this.company=companyData;
        }
      });

      this.companyUsageLimitsService.getForCompany(companyID)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)));
        })
      )
      .subscribe({
        next: data => {
          this.companyUsageLimits=data;
          if (this.currOrderUsageLimits != undefined) {
            this.populateFormFields(this.usageDetailsForm);
          }
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getUsageLimitsAndOpenModal(doNextOpenModalStep: boolean = true) {
    try {
      let orderID=this.sureSimOrder?.id==undefined ? -1 : this.sureSimOrder?.id;
      
      this.ordersService.getOrderUsageLimitsOrDefaults(<number>orderID)
      .pipe(
        catchError((error) => {          
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.currOrderUsageLimits=data;

          if (!this.getDataBeforeOpenModal) {
            this.populateFormFields(this.usageDetailsForm, true);
          }
          if (doNextOpenModalStep) {
            this.getLiveDataAndOpenModal();
          }
         },
        error: error => {
          this.eSimManagerFormCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public getLiveDataAndOpenModal() {
    try {
      let imeiIccid=this.sureSimDevice?.imeiIccid==undefined ? -1 : this.sureSimDevice?.imeiIccid;
      
      this.webbingService.getLiveDataByIccid(<string>imeiIccid)
      .pipe(
        catchError((error) => {          
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.maybeGotLiveDataAndOpenModal(data);
         },
        error: error => {
          let raiseError: boolean=true;

          if (error.message.includes(ErrorStrings.OriginalWebbingError)) {
            //error.message=error.message.replace(ErrorStrings.OriginalWebbingError, ErrorStrings.ReplacementWebbingError);
            raiseError=!this.suppressOriginalWebbingError;
            console.log(error.message);
            this.maybeGotLiveDataAndOpenModal(undefined);
          }
          
          this.eSimManagerFormCancelled.emit();

          if (raiseError)
            this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public maybeGotLiveDataAndOpenModal(webbingLiveData: WebbingLiveDataDTO | undefined) {
    try {
      this.sureSimLiveData=webbingLiveData;
      this.liveDataFetched=true;
      this.populateFormFields(this.orderDetailsForm);

      if (this.imeiLockFormIsOpen == true) {
        this.getSureSimDeviceAndOpenModal(false);
      } else {
        if (this.sureSimLiveData?.ImeiLockBreachRefresh == true) {
          this.imeiLockFormIsOpen=true; //This changes the logic in getSureSimDeviceAndOpenModal
          this.getSureSimDeviceAndOpenModal(false);
        }
        this.populateFormFields(this.usageDetailsForm);
        this.refreshUserData();
  
        if (this.getDataBeforeOpenModal) {
          this.openModal();
          this.selectOpenAtNavItem();
        }
      }

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private selectOpenAtNavItem(): void {
    try {
      if (this.openAtNavItem == undefined)
        return;

      const navItem     =this.openAtNavItem;
      this.openAtNavItem=undefined;

      setTimeout(() => this.arrowNav.select(navItem));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region SureSIM User
  
  public userSelectDropDownChange(ev: any) {
    try {
      if (this.userIdData==undefined)
        return;

      this.enableDisableControls(false);
      
      this.selectedUser=this.userIdData.find(x => x.id==this.orderDetailsForm.get('userId')?.value);
      let gotUser      =this.selectedUser?.id != undefined && <number>this.selectedUser?.id>0;      
  
      if (gotUser) {
        
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public viewUser() {
    try {
      let userId: number=this.orderDetailsForm.get('userId')?.value;
      
      if (!this.userModalFormIsOpen) {
        this.userModalFormIsOpen=true;
      
        this.userModalForm.openForm(userId, eUser.sim);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public userDataHasBeenSaved(sureSimUserId: number | undefined) {
    try {
      this.userModalFormIsOpen=false;

      if (sureSimUserId != undefined && <number>sureSimUserId>0) {
        this.getSureSimUserAndOpenModal(false);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public userFormHasBeenCancelled() {
    try {
      this.userModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Exclusion Profiles

  public setExclusionProfiles() {
    try {
      this.warningModalForm.openForm("Not Implemented", "Future work");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Manage Usage

  public manageUsage() {
    try {
      if (!this.usageLimitsModalFormIsOpen) {
        this.usageLimitsModalFormIsOpen=true;
        this.usageLimitsModalForm.openForm(this.sureSimOrder?.id ?? -1, this.usageLimitsChanged ? this.possibleOrderUsageLimits : undefined);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public usageLimitsModalFormSaved(orderUsageLimits: OrderUsageLimitsDTO) {
    try {
      this.usageLimitsModalFormIsOpen=false;

      this.possibleOrderUsageLimits=orderUsageLimits;
      this.usageLimitsChanged      =this.usageLimitsHaveChanged() ?? false;

      if (!this.submitButtonEnabled) {
        this.submitButtonEnabled=this.usageLimitsChanged;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public usageLimitsModalFormHasBeenCancelled() {
    try {
      this.usageLimitsModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public usageLimitsHaveChanged(): boolean | undefined {
    try {
      return this.currOrderUsageLimits?.dataLimit                      !=this.possibleOrderUsageLimits?.dataLimit                  ||
             this.currOrderUsageLimits?.dataLimitCurrent               !=this.possibleOrderUsageLimits?.dataLimitCurrent           ||
             this.currOrderUsageLimits?.dataLimitCurrentDataWeightCode !=this.possibleOrderUsageLimits?.dataLimitCurrentDataWeightCode ||
             this.currOrderUsageLimits?.dataLimitDataWeightCode        !=this.possibleOrderUsageLimits?.dataLimitDataWeightCode    ||
             this.currOrderUsageLimits?.limit                          !=this.possibleOrderUsageLimits?.limit                      ||
             this.currOrderUsageLimits?.limitCurrent                   !=this.possibleOrderUsageLimits?.limitCurrent               ||
             this.currOrderUsageLimits?.limitSelfAuth                  !=this.possibleOrderUsageLimits?.limitSelfAuth              ||
             this.currOrderUsageLimits?.limitType                      !=this.possibleOrderUsageLimits?.limitType;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  //#endregion

  //#region Product
  
  public productSelectDropDownChange(ev: any) {
    try {
      this.possibleProductID=this.orderDetailsForm.get('productId')?.value=='' ? undefined : this.orderDetailsForm.get('productId')?.value;
      this.productChanged   =this.productHasChanged() ?? false;

      if (!this.submitButtonEnabled) {
        this.submitButtonEnabled=this.productChanged;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public productHasChanged(): boolean | undefined {
    try {
      return this.possibleProductID != undefined &&
             this.currProduct       != undefined &&
             this.currProduct.id    != this.possibleProductID;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  //#endregion

  //#region Save Order

  public saveOrder() {
    try {
      this.sureSimOrder!.updatedByUserId= this.curUser.userId;
      this.mapSimLocations?.commitSimLocationSettings();

      if (this.productChanged) {
        this.sureSimOrder!.productID=this.possibleProductID ?? -1;
        this.webbingService.SetProduct(this.iccidForEmbeddedPages ?? "", this.possibleProductID ?? -1).pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            if (this.alertProduct != "") {
               this.removeAlertProduct(false);
            }
          },
          error: error => {
            if (error.message && error.message.includes("404")) {
              // this.warningMessageMain="Failed to set product";
              // this.warningMessageSub ="Please contact the application vendor for assistance";
              // this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
            } else {
              this.exceptionsService.handleException(new Error(error));
            }
          }
        });
      }

      if ((this.orderDetailsForm.controls['deviceTag'].value?.trim() ?? "") != (this.initialDeviceTag ?? "")) {
        this.devicesService.updateDeviceTag(this.orderDetailsForm.controls['liveIccid'].value?.trim(), 
                                            this.orderDetailsForm.controls['deviceTag'].value?.trim(),
                                            this.curUser.userId).pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
         },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
      }

      if (this.usageLimitsChanged) {
        this.sureSimOrder!.dataLimit                 =this.possibleOrderUsageLimits?.dataLimit;
        this.sureSimOrder!.dataLimitCurrent          =this.possibleOrderUsageLimits?.dataLimitCurrent;
        this.sureSimOrder!.dataLimitCurrentDataWeightCode=this.possibleOrderUsageLimits?.dataLimitCurrentDataWeightCode;
        this.sureSimOrder!.dataLimitDataWeightCode   =this.possibleOrderUsageLimits?.dataLimitDataWeightCode;
        this.sureSimOrder!.limit                     =this.possibleOrderUsageLimits?.limit;
        this.sureSimOrder!.limitCurrent              =this.possibleOrderUsageLimits?.limitCurrent;
        this.sureSimOrder!.limitSelfAuth             =this.possibleOrderUsageLimits?.limitSelfAuth;
        this.sureSimOrder!.limitType                 =this.possibleOrderUsageLimits?.limitType;

        if (this.sureSimOrder!.limitType===LimitType.Off) {
          this.sureSimOrder!.dataLimit                     =null;
          this.sureSimOrder!.dataLimitCurrent              =null;
          this.sureSimOrder!.dataLimitCurrentDataWeightCode=null;
          this.sureSimOrder!.dataLimitDataWeightCode       =null;
          this.sureSimOrder!.limit                         =null;
          this.sureSimOrder!.limitCurrent                  =null;
          this.sureSimOrder!.limitSelfAuth                 =null;
        } else if (this.sureSimOrder!.limitType===LimitType.Spend) {
          this.sureSimOrder!.dataLimit                     =null;
          this.sureSimOrder!.dataLimitCurrent              =null;
          this.sureSimOrder!.dataLimitCurrentDataWeightCode=null;
          this.sureSimOrder!.dataLimitDataWeightCode       =null;
        } else if (this.sureSimOrder!.limitType===LimitType.Data) {
          this.sureSimOrder!.limit                     =null;
          this.sureSimOrder!.limitCurrent              =null;
          this.sureSimOrder!.limitSelfAuth             =null;
        }
      }

      if (this.companyUsageLimits != undefined) {
        let keepLimitType: boolean=false;

        if (this.sureSimOrder!.limitType===LimitType.Off) {
          keepLimitType=(this.companyUsageLimits.limitType != LimitType.Off);
        } else if (this.sureSimOrder!.limitType===LimitType.Spend) {
          keepLimitType=(this.sureSimOrder!.limit != null        && this.sureSimOrder!.limit        != this.companyUsageLimits.limit) ||
                        (this.sureSimOrder!.limitCurrent != null  && this.sureSimOrder!.limitCurrent != this.sureSimOrder!.limit
                                                                  && this.sureSimOrder!.limitCurrent != this.companyUsageLimits.limit);
        } else if (this.sureSimOrder!.limitType===LimitType.Data) {
          keepLimitType=(this.sureSimOrder!.dataLimit != null        && this.sureSimOrder!.dataLimit        != this.companyUsageLimits.dataLimit) ||
                        (this.sureSimOrder!.dataLimitCurrent != null  && this.sureSimOrder!.dataLimitCurrent != this.sureSimOrder!.dataLimit
                                                                      && this.sureSimOrder!.dataLimitCurrent != this.companyUsageLimits.dataLimit);
        }

        if (this.sureSimOrder!.limitCurrent     == this.sureSimOrder!.limit     && this.sureSimOrder!.limit     == this.companyUsageLimits.limit)     this.sureSimOrder!.limitCurrent     =null;
        if (this.sureSimOrder!.dataLimitCurrent == this.sureSimOrder!.dataLimit && this.sureSimOrder!.dataLimit == this.companyUsageLimits.dataLimit) this.sureSimOrder!.dataLimitCurrent =null;

        if (this.sureSimOrder!.dataLimit     == this.companyUsageLimits.dataLimit)     this.sureSimOrder!.dataLimit     =null;
        if (this.sureSimOrder!.limit         == this.companyUsageLimits.limit)         this.sureSimOrder!.limit         =null;
        if (this.sureSimOrder!.limitSelfAuth == this.companyUsageLimits.limitSelfAuth) this.sureSimOrder!.limitSelfAuth =null;

        if (!keepLimitType) this.sureSimOrder!.limitType =null;
      }

      this.ordersService.save(<OrderDTO>this.sureSimOrder, this.usageLimitsChanged)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.sureSimOrder = data;

          if (this.usageLimitsChanged) {
            this.simLimitChanged();
          } else {
            this.processComplete();
          }
         },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Process Complete
  
  private processComplete() {
    try {
      this.completedModalForm.openForm("SIM Details Updated", "");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private processCompleteWithMessage(message : string) {
    try {
      this.doNotCloseForm = true;
      this.completedModalForm.openForm("Congratulations", message);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public completedModalHasBeenClosed() {
    try {
      if (!this.doNotCloseForm) {
        this.orderDataHasBeenSaved.emit();
        this.manageEsimModalFormRef.close();
      } else
      {
        this.orderStatusHasBeenUpdated.emit();
        this.doNotCloseForm = false;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region simLimitChanged

  public simLimitChanged() {
    try {
      this.limitChangeMessage = "SIM Details Updated";
      if (this.sureSimDevice?.imeiIccid != null)
      {
        this.devicesService.simLimitChanged(this.sureSimDevice?.imeiIccid, this.curUser?.userId)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            if (data == LimitChangeBarring.Barred) {
              this.limitChangeMessage = "SIM Details Updated, this SIM has exceeded its new spend limit so has been barred.";
            } else if (data == LimitChangeBarring.StillBarred) {
              this.limitChangeMessage = "SIM Details Updated, this new spend limit is below the sims current spend so has remained barred.";
            } else if (data == LimitChangeBarring.Unbarred) {
              this.limitChangeMessage = "SIM Details Updated, this SIM has been unbarred.";
            }

            this.limitProcessComplete();
          },
          error: error => {
            if (error.message && error.message.includes("404")) {
              // this.warningMessageMain="Failed to deprovision sim";
              // this.warningMessageSub ="Please contact the application vendor for assistance";
              // this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
            } else {
              this.exceptionsService.handleException(new Error(error));
            }
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private limitProcessComplete() {
    try {
      this.completedModalForm.openForm(this.limitChangeMessage, "");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region ngbNav
  
  public beforeTabChange(event: any) {
    try {
      this.activeIdPrevious=this.activeId;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public onTabChange(event: any) {
    try {
      if (this.activeId==this.navItemTimeline) {
        this.timelineButtonClick();
        this.arrowNav.select(this.activeIdPrevious);

      } else if (this.activeId==this.navItemUsageData) {
          this.getApplicationTotalUsage();
          this.getApplicationUsage();
          
          this.chartCostsPerDay?.getIccidTotalCost(this.sureSimDevice?.imeiIccid);
          this.chartUsagePerDay?.getIccidTotalUsage(this.sureSimDevice?.imeiIccid);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Charts

  //#region Application Charts

  private applicationBarPlotOptions(barCount: number): any {
    try {
      return {
        bar: {
          barHeight              : Math.min(70, Math.max(1, barCount)*11) + '%',
          borderRadius           : 4,
          borderRadiusApplication: 'end',
          dataLabels             : { position: 'top' },
          horizontal             : true
        }
      };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return { bar: { horizontal: true, dataLabels: { position: 'top' } } };
    }
  }

  public setUpApplicationDayChart(): void {
    try {
      let colors       : any     =this.chartConfigService.resolveColours(['--vz-suresim-blue']);
      const daysInMonth: string[]=[];

      if (this.applicationDayChart != undefined)
      {
        this.applicationDayChart={
          chart: {
            id     : 'application-day-usage-chart',
            height : 250,
            toolbar: {
                show: false,
            },
            type: 'bar'
          },
          colors     : colors,
          dataLabels: {
            enabled: true,
            formatter: function(val: number) {
              return val + "MB";
            },
            offsetY: 2,
            offsetX: 25,
            style: {
              fontSize: '10px',
              fontWeight: 'lighter',
              colors: ['#878a99']
            }
          },
          // plotOptions: {
          //   bar: {
          //     columnWidth: '90%',
          //     horizontal: true,
          //     dataLabels: {
          //       position: 'top'
          //     }
          //   }
          // },
          plotOptions: this.applicationBarPlotOptions(5),
          series     : this.subApplictionDaySeries,
          stroke     : {
            curve: 'smooth',
            width: [0, 3]
          },
          title: {
            style: {
              fontWeight: 600,
            },
            text: undefined
          },
          tooltip: {
            x: {
              formatter: function(val: string) {
                return val;
              }
            },
            y: {
              formatter: function(val: number) {
                return val + "MB";
              }
            }
          },
          legend: {
            show           : false,
            fontSize       : '10px'
          },
          xaxis: {
            type      : 'string',
            categories: daysInMonth,
            max       : this.maxDayValue,
            labels: {
              show    : true,
              minWidth: 15,
              style: {
                fontSize: '12px'
              },
            },
            title: {
              style: {
                fontWeight: 600,
              },
            text: 'Total Usage (MB)'
            },
          },
          yaxis: [{
            labels: {
              show    : true,
              minWidth: 15,
            }
          }]
        };
      }

      if (this.applicationMonthChart != undefined)
      {
        this.applicationMonthChart={
          chart: {
            id     : 'application-day-usage-chart',
            height : 250,
            toolbar: {
                show: false,
            },
            type: 'bar'
          },
          colors     : colors,
          dataLabels: {
            enabled: true,
            // position: 'end',
            formatter: function(val: number) {
              return val + "MB";
            },
            offsetY: 2,
            offsetX: 25,
            style: {
              fontSize: '10px',
              fontWeight: 'lighter',
              colors: ['#878a99']
            }
          },
          // plotOptions: {
          //   bar: {
          //     columnWidth: '90%',
          //     horizontal: true,
          //     dataLabels: {
          //       position: 'top'
          //     }
          //   }
          // },
          plotOptions: this.applicationBarPlotOptions(5),
          series     : this.subApplictionMonthSeries,
          stroke     : {
            curve: 'smooth',
            width: [0, 3]
          },
          title: {
            style: {
              fontWeight: 600,
            },
            text: undefined
          },
          tooltip: {
            x: {
              formatter: function(val: string) {
                return val;
              }
            },
            y: {
              formatter: function(val: number) {
                return val + "MB";
              }
            }
          },
          legend: {
            show           : false,
            fontSize       : '10px'
          },
          xaxis: {
            type      : 'string',
            categories: daysInMonth,
            max       : this.maxMonthValue,
            labels: {
              show    : true,
              minWidth: 15,
              style: {
                fontSize: '12px'
              },
            },
            title: {
              style: {
                fontWeight: 600,
              },
              text: 'Total Usage (MB)'
            },
          },
          yaxis: [{
            labels: {
              show    : true,
              minWidth: 15,
            }
          }]
        };
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private getApplicationTotalUsage() {
    try {
      if (this.sureSimDevice==undefined)
        return;

      // if (this.showApplicationUsage) {
          this.widgetService.getApplicationTotalUsage(-1,
                                                this.sureSimDevice?.imeiIccid ?? "",
                                                -1,
                                                <number>(this.chartFilterDate?.year ?? 1),
                                                <number>(this.chartFilterDate?.month ?? 1),
                                                1)
                            .pipe(
                              catchError((error) => {          
                                return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
                              })
                            )
                            .subscribe({
                              next: data => {
                                  this.applicationTotalData               =data;
                                  this.subApplicationsMonth               = [];
                                  this.subApplictionMonthSeries           = [];

                                  data.sort((a, b) => Number(b.totalUsage) - Number(a.totalUsage));
                                  let firstFiveItems = data.slice(0, 5);
                                  this.subApplicationsMonth               = Array.from(firstFiveItems.map(daydata => daydata.application)); 
                      
                                  let applicationsData = Array.from(firstFiveItems.map(daydata => Number(daydata.totalUsage)));
                                  let newseries = {name:"Total Usage", type: "bar", data:applicationsData}
                                  this.subApplictionMonthSeries.push(newseries);
                                  
                                  //let applicationcolors: any=this.chartConfigService.resolveColours(this.chartConfigService.defaultColoursArray);
                                  let applicationcolors: any=this.chartConfigService.resolveColours(['--vz-suresim-blue']);

                                  this.applicationTotalUsageForCurrentMonthChart(applicationcolors);
                                  this.loadingTotalChart = false;
                              },
                              error: error => {
                                this.exceptionsService.handleException(new Error(error));
                              }
                            });
      //   } else
      //   {
      //       this.widgetService.getApplicationTotalUsage(-1,
      //                                                   this.sureSimDevice?.imeiIccid ?? "",
      //                                                   -1,
      //                                                   <number>this.chartFilterDate.year,
      //                                                   <number>this.chartFilterDate.month,
      //                                                   1)
      //                         .pipe(
      //                           catchError((error) => {          
      //                             return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
      //                           })
      //                         )
      //                         .subscribe({
      //                           next: data => {
      //                             this.applicationTotalData=data
      //                           },
      //                           error: error => {
      //                             this.exceptionsService.handleException(new Error(error));
      //                           }
      //                         });
      // }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private CalculateApplicationMaxDay() {
    try {
      this.maxDayValue = 0;
      if (this.applicationData != undefined && this.applicationData.length > 0) {
        let max = this.applicationData.reduce((prev, current) => {
          return (Number(prev.totalUsage) > Number(current.totalUsage)) ? prev : current;
        });
        this.maxDayValue = Number(max.totalUsage);

        if (this.maxDayValue < 1) {
          this.maxDayValue = 1.5;
        } else if (this.maxDayValue < 2) {
          this.maxDayValue = 2.5;
        } else {
          this.maxDayValue = Number(max.totalUsage) * 1.2;
          let i = Math.ceil(this.maxDayValue);
          let denominator = 0;
          if (i < 10) {
            denominator = 1;
          } else if (i < 50) {
            denominator = 5;
          } else if (i < 100) {
            denominator = 10;
          } else if (i < 500) {
            denominator = 50;
          } else if (i < 1000) {
            denominator = 100;
          } else if (i < 5000) {
            denominator = 500;
          } else if (i < 10000) {
            denominator = 1000;
          } else if (i < 50000) {
            denominator = 5000;
          } else {
            denominator = 10000;
          }

          while (i % denominator != 0) {
            i++;
          }
          this.maxDayValue = i;
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private CalculateApplicationMaxMonth() {
    try {
      this.maxMonthValue = 0;
      if (this.applicationTotalData != undefined && this.applicationTotalData.length > 0) {
        let max = this.applicationTotalData.reduce((prev, current) => {
          return (Number(prev.totalUsage) > Number(current.totalUsage)) ? prev : current;
        });
        this.maxMonthValue = Number(max.totalUsage);

        if (this.maxMonthValue < 1) {
          this.maxMonthValue = 1.5;
        } else if (this.maxMonthValue < 2) {
          this.maxMonthValue = 2.5;
        } else {
          this.maxMonthValue = Number(max.totalUsage) * 1.2;
          let i = Math.ceil(this.maxMonthValue);
          let denominator = 0;
          if (i < 10) {
            denominator = 1;
          } else if (i < 50) {
            denominator = 5;
          } else if (i < 100) {
            denominator = 10;
          } else if (i < 500) {
            denominator = 50;
          } else if (i < 1000) {
            denominator = 100;
          } else if (i < 5000) {
            denominator = 500;
          } else if (i < 10000) {
            denominator = 1000;
          } else if (i < 50000) {
            denominator = 5000;
          } else {
            denominator = 10000;
          }

          while (i % denominator != 0) {
            i++;
          }
          this.maxMonthValue = i;
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applicationTotalUsageForCurrentMonthChart(colors: any) {
    try {
      const applications = Array.from(new Set(this.subApplicationsMonth));

      if (this.applicationDayBorder &&
          this.applicationDayBorder.nativeElement &&
          this.applicationMonthBorder &&
          this.applicationMonthBorder.nativeElement &&
          this.applicationData != undefined &&
          this.applicationData.length == 0 &&
          this.applicationTotalData != undefined
          && this.applicationTotalData.length > 0) {
        this.applicationDayBorder.nativeElement.style.height   = '381px';
        this.applicationMonthBorder.nativeElement.style.height = '381px';
      }

      this.CalculateApplicationMaxMonth();

      this.applicationMonthChart={
        chart: {
          id     : 'application-usage-chart',
          height : 250,
          toolbar: {
              show: false,
          },
          type: 'bar'
        },
        colors     : colors,
        dataLabels: {
          enabled: true,
          formatter: function(val: number) {
            return val + "MB";
          },
          offsetY: 2,
          offsetX: 25,
          style: {
            fontSize: '10px',
            fontWeight: 'lighter',
            colors: ['#878a99']
          }
        },
        // plotOptions: {
        //   bar: {
        //     columnWidth: '90%',
        //     horizontal: true,
        //     dataLabels: {
        //       position: 'top'
        //     }
        //   }
        // },
        plotOptions: this.applicationBarPlotOptions(applications.length),
        series     : this.subApplictionMonthSeries,
        stroke     : {
          curve: 'smooth',
          width: [0, 3]
        },
        title: {
          style: {
            fontWeight: 600,
          },
          text: undefined
        },
        tooltip: {
          x: {
            formatter: function(val: string) {
              return val;
            }
          },
          y: {
            formatter: function(val: number) {
              return val + "MB";
            }
          }
        },
        legend: {
          show           : false,
          fontSize       : '10px'
        },
        xaxis: {
          type      : 'string',
          categories: applications,
          max       : this.maxMonthValue,
          labels: {
            show    : true,
            minWidth: 15,
            style: {
              fontSize: '12px'
            },
          },
          title: {
            style: {
              fontWeight: 600,
            },
          text: 'Total Usage (MB)'
          },
        },
        yaxis: [{
          labels: {
            show    : true,
            minWidth: 15,
          }
        }]
      };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private getApplicationUsage() {
    try {
      if (this.sureSimDevice==undefined)
        return;

      // if (this.showApplicationUsage) {
          this.widgetService.getApplicationUsage(-1,
                                                this.sureSimDevice?.imeiIccid ?? "",
                                                -1,
                                                <number>(this.chartFilterDate?.year ?? 1),
                                                <number>(this.chartFilterDate?.month ?? 1),
                                                <number>(this.chartFilterDate?.day ?? 1),
                                                DateRange.Day, 
                                                EspSystemEntities.ImeiIccid)
                            .pipe(
                              catchError((error) => {          
                                return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
                              })
                            )
                            .subscribe({
                              next: data => {
                                  this.applicationData                  = data;
                                  this.subApplicationsDay               = [];
                                  this.subApplictionDaySeries           = [];
                                  data.sort((a, b) => Number(b.totalUsage) - Number(a.totalUsage));
                                  let firstFiveItems = data.slice(0, 5);
                                  this.subApplicationsDay               = Array.from(firstFiveItems.map(daydata => daydata.application)); 
                      
                                  let applicationsData = Array.from(firstFiveItems.map(daydata => Number(daydata.totalUsage)));
                                  let newseries = {name:"Total Usage", type: "bar", data:applicationsData}
                                  this.subApplictionDaySeries.push(newseries);
                                  
                                  //let applicationcolors: any=this.chartConfigService.resolveColours(this.chartConfigService.defaultColoursArray);
                                  let applicationcolors: any=this.chartConfigService.resolveColours(['--vz-suresim-blue']);

                                  this.applicationTotalUsageForCurrentDayChart(applicationcolors);
                                  this.loadingChart =false;
                              },
                              error: error => {
                                this.exceptionsService.handleException(new Error(error));
                              }
                            });
      //   } else
      //   {
      //       this.widgetService.getApplicationTotalUsage(-1,
      //                                                   this.sureSimDevice?.imeiIccid ?? "",
      //                                                   -1,
      //                                                   <number>this.chartFilterDate.year,
      //                                                   <number>this.chartFilterDate.month,
      //                                                   1)
      //                         .pipe(
      //                           catchError((error) => {          
      //                             return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
      //                           })
      //                         )
      //                         .subscribe({
      //                           next: data => {
      //                             this.applicationTotalData=data
      //                           },
      //                           error: error => {
      //                             this.exceptionsService.handleException(new Error(error));
      //                           }
      //                         });
      // }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applicationTotalUsageForCurrentDayChart(colors: any) {
    try {
      const applications = Array.from(new Set(this.subApplicationsDay));

      if (this.applicationDayBorder &&
          this.applicationDayBorder.nativeElement &&
          this.applicationMonthBorder &&
          this.applicationMonthBorder.nativeElement &&
          this.applicationData != undefined &&
          this.applicationData.length == 0 &&
          this.applicationTotalData != undefined &&
          this.applicationTotalData.length > 0) {
        this.applicationDayBorder.nativeElement.style.height   = '381px';
        this.applicationMonthBorder.nativeElement.style.height = '381px';
      }

      this.CalculateApplicationMaxDay();

      this.applicationDayChart={
        chart: {
          id     : 'application-usage-chart',
          height : 250,
          toolbar: {
              show: false,
          },
          type: 'bar'
        },
        colors     : colors,
        dataLabels: {
          enabled: true,
          formatter: function(val: number) {
            return val + "MB";
          },
          offsetY: 2,
          offsetX: 25,
          style: {
            fontSize: '10px',
            fontWeight: 'lighter',
            colors: ['#878a99']
          }
        },
        // plotOptions: {
        //   bar: {
        //     columnWidth: '90%',
        //     horizontal: true,
        //     dataLabels: {
        //       position: 'top'
        //     }
        //   }
        // },
        plotOptions: this.applicationBarPlotOptions(applications.length),
        series     : this.subApplictionDaySeries,
        stroke     : {
          curve: 'smooth',
          width: [0, 3]
        },
        title: {
          style: {
            fontWeight: 600,
          },
          text: undefined
        },
        tooltip: {
          x: {
            formatter: function(val: string) {
              return val;
            }
          },
          y: {
            formatter: function(val: number) {
              return val + "MB";
            }
          }
        },
        legend: {
          show           : false,
          fontSize       : '10px'
        },
        xaxis: {
          type      : 'string',
          categories: applications,
          max       : this.maxDayValue,
          labels: {
            show    : true,
            minWidth: 15,
            style: {
              fontSize: '12px'
            },
          },
          title: {
            style: {
              fontWeight: 600,
            },
            text: 'Total Usage (MB)'
          },
        },
        yaxis: [{
          labels: {
            show    : true,
            minWidth: 15,
          }
        }]
      };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#endregion

  //#region Logs
  
  //#region SIM Log

  public getEsimLogProfile(iccid: string, orderid: number) {
    try {
      this.webbingService.getEsimLogProfile(iccid, orderid)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.maybeGotEsimLogProfile(data);
         },
        error: error => {
          let raiseError: boolean=true;

          if (error.message.includes(ErrorStrings.OriginalWebbingError)) {
            //error.message=error.message.replace(ErrorStrings.OriginalWebbingError, ErrorStrings.ReplacementWebbingError);
            raiseError=!this.suppressOriginalWebbingError;
            console.log(error.message);
            this.maybeGotEsimLogProfile(undefined);
          }
          
          this.eSimManagerFormCancelled.emit();

          if (raiseError)
            this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public maybeGotEsimLogProfile(esimLogProfile: EsimLogProfileDTO | undefined) {
    try {
      this.eSimLogProfile=esimLogProfile;
      this.populateFormFields(this.logsEsimForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#endregion

  //#region Live View

  public timelineButtonClick() {
    try {
      this.timelineModalForm.openForm(this.sureSimDevice?.imeiIccid);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Risk Intelligence

  public openRiskTripReady(): void {
    try {
      this.riskButtonClick.emit({
        companyID  : this.sureSimOrder?.companyID                  ?? 0,
        lastCountry: this.sureSimOrder?.orderSpendDTO?.lastCountry ?? ''
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region SIM Operations

  public bar() {
    try {
      if (this.sureSimDevice?.imeiIccid != null && !this.simOpertationInProgress)
        {
          this.startSimOperation()
          this.devicesService.bar(this.sureSimDevice?.imeiIccid, this.curUser.userId)
          .pipe(
            catchError((error) => {
              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
            })
          )
          .subscribe({
            next: data => {
              this.updateStatus();
              this.stopSimOperation();
              this.processCompleteWithMessage("The SIM has been barred");
            },
            error: error => {
              this.stopSimOperation();
              if (error.message && error.message.includes("404")) {
                // this.warningMessageMain="Failed to enable sim";
                // this.warningMessageSub ="Please contact the application vendor for assistance";
                // this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
              } else {
                this.exceptionsService.handleException(new Error(error));
              }
            }
          });
        }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public deprovisionSim() {
    try {
      this.deleteSimConfirmationModal.openForm("Delete SIM", "Are you sure?");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e); 
    }
  }

  public resetNetwork() {
    try {
      this.resetNetworkConfirmationModal.openForm("Reset Network",
                                                  "Resetting the network will cause the device to lose connectivity for up to two minutes. Application usage data is also reset when using this feature",
                                                  undefined,
                                                  undefined,
                                                  undefined,
                                                  "Continue",
                                                  "Cancel");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public yesResetNetwork() {
    try {
      if (this.sureSimDevice?.imeiIccid != null && this.currProduct?.id != undefined && !this.simOpertationInProgress)
      {
        this.startSimOperation();
        this.webbingService.ResetNetwork(this.sureSimDevice?.imeiIccid, Number(this.currProduct.id), this.curUser.userId)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.stopSimOperation();
            this.processCompleteWithMessage("The network reset has been initiated. The device may lose connectivity for up to two minutes.");
          },
          error: error => {
            this.stopSimOperation();
            if (error.message && error.message.includes("404")) {
            } else {
              this.exceptionsService.handleException(new Error(error));
            }
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public changeLimit() {
    try {
      try {
        if (!this.usageLimitsModalFormIsOpen) {
          this.usageLimitsModalFormIsOpen=true;
          this.usageLimitsModalForm.openForm(this.sureSimOrder?.id ?? -1, this.usageLimitsChanged ? this.possibleOrderUsageLimits : undefined);
        }
      }
      catch(e) {
        this.exceptionsService.handleException(<Error>e);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public deprovision() {
    try {
      if (this.sureSimDevice?.imeiIccid != null && !this.simOpertationInProgress)
      {
        this.startSimOperation();
        this.devicesService.deprovision(this.sureSimDevice?.imeiIccid, this.curUser.userId)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.enableDisableSimOperations('Ceased');
            this.processCompleteWithMessage("The SIM has been ceased");
          },
          error: error => {
            this.stopSimOperation();
            if (error.message && error.message.includes("404")) {
              // this.warningMessageMain="Failed to cease sim";
              // this.warningMessageSub ="Please contact the application vendor for assistance";
              // this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
            } else {
              this.exceptionsService.handleException(new Error(error));
            }
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onBarredCheckboxChange(event: Event) {
    try {
      const isChecked = (event.target as HTMLInputElement).checked;
      this.barred     = isChecked;
      if (isChecked) {
        this.orderDetailsForm.controls["throttled64"].setValue(false);
        this.orderDetailsForm.controls["throttled512"].setValue(false);
        this.orderDetailsForm.controls["throttled64"].disable();
        this.orderDetailsForm.controls["throttled512"].disable();
        this.bar();
      } else {
        this.orderDetailsForm.controls["throttled64"].enable();
        this.orderDetailsForm.controls["throttled512"].enable();
        this.unbar();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openMoreForm() {
    try {
      if (!this.manageMoreFormIsOpen && this.sureSimDevice && this.sureSimOrder) {        
        let sureSimOrderDetails: OrderMiniDTO={
          alertProduct: this.sureSimDevice.alertProduct == "" ? "No" : this.sureSimDevice.alertProduct,
          iccid       : this.sureSimDevice.imeiIccid,
          orderID     : this.sureSimOrder.id,
          orderNo     : this.sureSimOrder.orderNo,
          status      : this.sureSimOrder.status,
          username    : this.userIdData.find(x => x.id==this.orderDetailsForm.get('userId')?.value)?.description ?? "",
          systemUserID: this.curUser.userId
        }
        
        this.manageMoreFormIsOpen=true;
        this.manageEsimMore.openForm(sureSimOrderDetails);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public moreFormHasBeenSaved() {
    try {
      this.manageMoreFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public moreFormHasBeenCancelled(refreshGrid: boolean) {
    try {
      if (refreshGrid) {
        this.ordersService.getOrderIdByIccid(this.sureSimDevice?.imeiIccid ?? "")
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.sureSimOrderId   = data.result;
            this.sureSimOrder!.id = this.sureSimOrderId;
            this.getSureSimDeviceAndOpenModal(false);
            this.getUsageLimitsAndOpenModal(false);
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      } else {
        this.manageMoreFormIsOpen=false; //RBW 20250902 - this also gets turned off in getSureSimDeviceAndOpenModal
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onSuspendedCheckboxChange(event: Event) {
    try {
      const isChecked = (event.target as HTMLInputElement).checked;
      if (isChecked) {
        this.suspend();
      } else {
        this.unsuspend();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onThrottled64CheckboxChange(event: Event) {
    try {
      const isChecked = (event.target as HTMLInputElement).checked;
      if (isChecked) {
        this.orderDetailsForm.controls["throttled512"].setValue(false);
        this.throttle(ThrottleType.Throttle64k);
      } else if (!this.orderDetailsForm.controls["throttled512"].value) {
        this.unthrottle();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onThrottled512CheckboxChange(event: Event) {
    try {
      const isChecked = (event.target as HTMLInputElement).checked;
      if (isChecked) {
        this.orderDetailsForm.controls["throttled64"].setValue(false);
        this.throttle(ThrottleType.Throttle512k);
      }else if (!this.orderDetailsForm.controls["throttled64"].value) {
        this.unthrottle();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public imeiLocking() {
    try {
      if (this.sureSimOrder?.status != "Ceased") {
        if (this.sureSimOrder?.latestOrder == true) {
          if (!this.imeiLockFormIsOpen && this.sureSimDevice && this.sureSimOrder) {        
            let sureSimOrderDetails: OrderMiniDTO={
              alertProduct: this.sureSimDevice.alertProduct == "" ? "No" : this.sureSimDevice.alertProduct,
              iccid       : this.sureSimDevice.imeiIccid,
              orderID     : this.sureSimOrder.id,
              orderNo     : this.sureSimOrder.orderNo,
              status      : this.sureSimOrder.status,
              username    : this.userIdData.find(x => x.id==this.orderDetailsForm.get('userId')?.value)?.description ?? "",
              systemUserID: this.curUser.userId
            }
            
            this.imeiLockFormIsOpen=true;
            this.imeiLockEsim.openForm(sureSimOrderDetails,this.sureSimDevice.deviceTypeID,this.sureSimOrder.imeiLocking ?? "", this.sureSimLiveData?.IMEI ?? "");
          }
        } else {
          if (this.sureSimOrder?.liveOnAnotherCompany == true) {
            this.warningModalForm.openForm("WARNING", "This sim can no longer be IMEI locked.");
          } else {
            this.warningModalForm.openForm("WARNING", "Only the latest order for this sim can be used to lock the IMEI.");
          }       
        }
      } else {
        this.warningModalForm.openForm("WARNING", "SIM must be live to lock the IMEI.");
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public redeploy() {
    try {
      if (this.sureSimOrder?.status == "Removed" || 
          this.sureSimOrder?.status == "Sent - SMS/email" || 
          this.sureSimOrder?.status == "Awaiting Download" || 
          this.sureSimOrder?.status == "Awaiting Deployment") {
        if (this.sureSimOrder?.latestOrder == true) {
          if (!this.redeployFormIsOpen && this.sureSimDevice && this.sureSimOrder) {        
            let sureSimOrderDetails: OrderMiniDTO={
              alertProduct: this.sureSimDevice.alertProduct == "" ? "No" : this.sureSimDevice.alertProduct,
              iccid       : this.sureSimDevice.imeiIccid,
              orderID     : this.sureSimOrder.id,
              orderNo     : this.sureSimOrder.orderNo,
              status      : this.sureSimOrder.status,
              username    : this.userIdData.find(x => x.id==this.orderDetailsForm.get('userId')?.value)?.description ?? "",
              systemUserID: this.curUser.userId
            }
            
            this.redeployFormIsOpen=true;
            this.redeployEsim.openForm(sureSimOrderDetails,this.sureSimDevice.deviceTypeID,this.sureSimOrder.eid,this.sureSimDevice.activated ?? false);
          }
        } else {
          if (this.sureSimOrder?.liveOnAnotherCompany == true) {
            this.warningModalForm.openForm("WARNING", "This sim is no longer available for redeployment.");
          } else {
            this.warningModalForm.openForm("WARNING", "Only the latest order for this sim can be used to redeploy it.");
          }       
        }
      } else {
        this.warningModalForm.openForm("WARNING", "SIM must be removed from the device before it can be redeployed.");
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }


  public imeiLockingCancelled() {
    this.imeiLockFormIsOpen=false;
  }

  public imeiLockingOrderUpdated(data: IdAndDescriptionDTO) { //data: { orderId: number, imeiLocks: string}
    if (this.sureSimOrder != null) {
      this.sureSimOrderId                = Number(data.id);
      this.sureSimOrder.id               = Number(data.id);
      this.sureSimOrder.imeiLocking      = data.description;

      if (this.sureSimOrder != undefined) {
        this.orderDetailsForm.controls["imeiLocking"].setValue(this.sureSimOrder.imeiLocking);

        this.getLiveDataAndOpenModal();
      } 
    }
  }

  public imeiLockingSuccessful() {
    //this.getSureSimDeviceAndOpenModal(false);
    //this.imeiLockFormIsOpen=false; This is done within getSureSimDeviceAndOpenModal
  }


  public redeployCancelled() {
    this.redeployFormIsOpen=false;
  }

  public redeployOrderUpdated(data: { orderId: number, eid: string}) {
    if (this.sureSimOrder != null) {
      this.sureSimOrderId                = data.orderId;
      this.sureSimOrder.id               = data.orderId;
      this.sureSimOrder.eid              = data.eid;
      this.sureSimOrder.deprovisioned    = false;
      this.sureSimOrder.deprovisionedDate= null;
      this.sureSimOrder.released         = false;
      this.sureSimOrder.releasedDate     = null;

      if (this.sureSimOrder != undefined) {
        this.orderDetailsForm.controls["eid"].setValue(this.sureSimOrder.eid);
      } 
    }
  }

  public redeploySuccessful() {
    this.getSureSimDeviceAndOpenModal(false);
    //this.redeployFormIsOpen=false; This is done within getSureSimDeviceAndOpenModal
  }

  public removeAlertProduct(showConfirmation:boolean=true) {
    try {
      if (this.sureSimDevice?.imeiIccid != null)
        {
          this.devicesService.removeAlertProductSim(this.sureSimDevice?.imeiIccid, this.curUser.userId)
          .pipe(
            catchError((error) => {
              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
            })
          )
          .subscribe({
            next: data => {
              this.alertProduct = "";
              if (showConfirmation) {
                this.updateStatus();
                this.processCompleteWithMessage("The SIM has been moved back onto it's assigned product.");
              }
            },
            error: error => {
              if (error.message && error.message.includes("404")) {
                // this.warningMessageMain="Failed to enable sim";
                // this.warningMessageSub ="Please contact the application vendor for assistance";
                // this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
              } else {
                this.exceptionsService.handleException(new Error(error));
              }
            }
          });
        }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public startSimOperation(showSpinner:boolean=true) {
    try {
      this.simOpertationInProgress = true;
      this.simOperationShowSpinner = showSpinner;
      this.orderDetailsForm.controls["suspended"].disable();
      this.orderDetailsForm.controls["barred"].disable();
      this.orderDetailsForm.controls["throttled64"].disable();
      this.orderDetailsForm.controls["throttled512"].disable();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public stopSimOperation() {
    try {
      this.simOpertationInProgress = false;
      this.simOperationShowSpinner = false;
      this.orderDetailsForm.controls["suspended"].enable();
      this.orderDetailsForm.controls["barred"].enable();
      if (!this.barred) {
        this.orderDetailsForm.controls["throttled64"].enable();
        this.orderDetailsForm.controls["throttled512"].enable();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public suspend() {
    try {
      if (this.sureSimDevice?.imeiIccid != null && !this.simOpertationInProgress)
      {
        this.startSimOperation();
        this.devicesService.suspend(this.sureSimDevice?.imeiIccid, this.curUser.userId)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.updateStatus();
            this.stopSimOperation();
            this.processCompleteWithMessage("The SIM has been suspended");
          },
          error: error => {
            this.stopSimOperation();
            if (error.message && error.message.includes("404")) {
              // this.warningMessageMain="Failed to suspend sim";
              // this.warningMessageSub ="Please contact the application vendor for assistance";
              // this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
            } else {
              this.exceptionsService.handleException(new Error(error));
            }
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public throttle(throttleSpeedTypeId :number) {
    try {
      if (this.sureSimDevice?.imeiIccid != null && !this.simOpertationInProgress)
      {
        this.startSimOperation();
        this.devicesService.throttle(this.sureSimDevice?.imeiIccid, throttleSpeedTypeId, this.curUser.userId)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.updateStatus();
            this.stopSimOperation();
            this.processCompleteWithMessage("The SIM has been throttled");
          },
          error: error => {
            this.stopSimOperation();
            if (error.message && error.message.includes("404")) {
              // this.warningMessageMain="Failed to suspend sim";
              // this.warningMessageSub ="Please contact the application vendor for assistance";
              // this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
            } else {
              this.exceptionsService.handleException(new Error(error));
            }
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public unbar() {
    try {
      if (this.sureSimDevice?.imeiIccid != null && !this.simOpertationInProgress)
        {
          this.startSimOperation();
          this.devicesService.unbar(this.sureSimDevice?.imeiIccid, this.curUser.userId)
          .pipe(
            catchError((error) => {
              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
            })
          )
          .subscribe({
            next: data => {
              this.updateStatus();
              this.stopSimOperation();
              this.processCompleteWithMessage("The SIM has been unbarred");
            },
            error: error => {
              this.stopSimOperation();
              if (error.message && error.message.includes("404")) {
                // this.warningMessageMain="Failed to enable sim";
                // this.warningMessageSub ="Please contact the application vendor for assistance";
                // this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
              } else {
                this.exceptionsService.handleException(new Error(error));
              }
            }
          });
        }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public unsuspend() {
    try {
      if (this.sureSimDevice?.imeiIccid != null && !this.simOpertationInProgress)
        {
          this.startSimOperation();
          this.devicesService.unsuspend(this.sureSimDevice?.imeiIccid, this.curUser.userId)
          .pipe(
            catchError((error) => {
              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
            })
          )
          .subscribe({
            next: data => {
              this.updateStatus();
              this.stopSimOperation();
              this.processCompleteWithMessage("The SIM has been unsuspended");
            },
            error: error => {
              this.stopSimOperation();
              if (error.message && error.message.includes("404")) {
                // this.warningMessageMain="Failed to enable sim";
                // this.warningMessageSub ="Please contact the application vendor for assistance";
                // this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
              } else {
                this.exceptionsService.handleException(new Error(error));
              }
            }
          });
        }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public unthrottle() {
      if (this.sureSimDevice?.imeiIccid != null && !this.simOpertationInProgress)
        {
          this.startSimOperation();
          this.devicesService.unthrottle(this.sureSimDevice?.imeiIccid, this.curUser.userId)
          .pipe(
            catchError((error) => {
              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
            })
          )
          .subscribe({
            next: data => {
              this.updateStatus();
              this.stopSimOperation();
              this.processCompleteWithMessage("The SIM has been unthrottled");
            },
            error: error => {
              this.stopSimOperation();
              if (error.message && error.message.includes("404")) {
                // this.warningMessageMain="Failed to enable sim";
                // this.warningMessageSub ="Please contact the application vendor for assistance";
                // this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
              } else {
                this.exceptionsService.handleException(new Error(error));
              }
            }
          });
        }
  }

  public enableDisableSimOperations(status : string) {
    this.ceased = (status == "Ceased"); 
    if (this.ceased || this.simOpertationInProgress) {
      this.orderDetailsForm.controls["barred"].disable();
      this.orderDetailsForm.controls["suspended"].disable();
      this.orderDetailsForm.controls["throttled64"].disable();
      this.orderDetailsForm.controls["throttled512"].disable();
    } else {
      this.stopSimOperation();
    }
  }

  public updateStatus() {
    try {
      if (this.sureSimDevice?.imeiIccid != null) {
        this.ordersService.getOrderStatus(<number>this.sureSimOrderId)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            if (this.sureSimOrder != undefined) {
              this.sureSimOrder.status        = data.status;
              this.sureSimOrder.statusDisplay = data.statusDisplay;
              this.sureSimOrder.statusIcon    = data.statusIcon;
              this.orderDetailsForm.controls["status"].setValue(data.status);
              this.orderDetailsForm.controls["statusDisplay"].setValue(data.statusDisplay);
              this.orderDetailsForm.controls["statusIcon"].setValue(data.statusIcon);
              this.enableDisableSimOperations(data.status);
            }
          },
          error: error => {
            if (error.message && error.message.includes("404")) {
              // this.warningMessageMain="Failed to enable sim";
              // this.warningMessageSub ="Please contact the application vendor for assistance";
              // this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
            } else {
              this.exceptionsService.handleException(new Error(error));
            }
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public yesDeleteSim() {
    try {
      this.deprovision();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
  
  //#region Features
  
  public enableFeatures() {
    try {
      if (!this.enableFeaturesHasExecuted) {
        this.enableFeaturesHasExecuted=true;
        
        this.enableFeatureApplicationGraphs();
        this.enableFeatureLocationServices();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public enableFeatureApplicationGraphs() {
    try {
      if (!this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormManageApplicationUsageShow, false)) {
        this.featureEnabledApplicationGraphs=false;

      } else {
        this.licencesCompanyAllocatedService.companyHasLicenceFeatureByGuid(this.sureSimOrder?.companyID ?? -1, AccessGuids.ChargeableFeatureApplicationSummaries)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.featureEnabledApplicationGraphs=data.result;
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public enableFeatureLocationServices() {
    try {
      this.licencesCompanyAllocatedService.companyHasLicenceFeatureByGuid(this.sureSimOrder?.companyID ?? -1, AccessGuids.ChargeableFeatureLocationServices)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.featureEnabledLocationServices=data.result;
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region System Lock
  
  private processSystemLock(): void {
    try {
      if (!this.systemLocksEnabled)
        return;

      const systemLock: SystemLockDTO={
        active    : true,
        enteredBy : this.curUser.userId,
        entityID  : SystemLocks.DummyOrderLockId,
        entityLock: this.sureSimOrder?.orderNo ?? "",
        id        : -1
      };
    
      this.systemLockService.entityIsLocked(systemLock)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          const possibleSystemLock: SystemLockDTO=data;

          if (possibleSystemLock.locked) {

            if (possibleSystemLock.sameUserLock) {
              this.systemLockId=possibleSystemLock.id;
            }
            else {
              this.formIsLocked=true;
              const lockDetail =`Order is being edited by\n\n${possibleSystemLock.enteredByName}\n\nas of ${this.datePipe.transform(possibleSystemLock.enteredDate, 'dd/MM/yyyy HH:mm:ss')}`;

              if (this.systemLocksShowDetails)
                this.fileLockHoverText=lockDetail;

              if (this.systemLocksShowWarningModal) {
                this.warningModalForm.openForm("WARNING",
                                               (<string>this.fileLockHoverText).replaceAll("\n", "<br>") + "<br><br>Changes are not permitted until the Edit is complete",
                                               "https://cdn.lordicon.com/fikcyfpp.json");
              }

              this.lockDownForm();
            }

          } else {
            this.lockEntity(systemLock);
          }
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private lockEntity(systemLock: SystemLockDTO): void {
    try {
      this.systemLockService.lockEntity(systemLock)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.systemLockId=data.id;
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private unlockEntity(): void {
    try {
      if (!this.systemLocksEnabled || !this.systemLockId || this.systemLockId<0)
        return;

      this.systemLockService.unlockEntity(this.systemLockId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private lockDownForm(): void {
    try {
      this.orderDetailsForm.get("productId")?.disable();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
}
